module.exports = __webpack_public_path__ + "img/option3.fd5f344b.png";